import Vue from 'vue';
import api from '../../api/user'
import CONFIG from '@/constants/config.js';

const methods={
  getXSRFToken(){
    try{
      return document.cookie.match(new RegExp(`XSRF-TOKEN=([^;]+)`))[1];
    }catch(ex){
      console.warn(ex);
    }
    return null;
  },
  getJWTToken(response){
    if(process.env.NODE_ENV === 'development'){
      return ''
    }
    return (response.headers)?response.headers['set-cookie']:null;
  },
  getStoredToken(){
    return (localStorage)?(localStorage.getItem('app-token') || ''):'';
  },
  setStoredToken(token){
    if(localStorage){
      //axios.defaults.headers.common['Authorization'] = token;
      localStorage.setItem('app-token', token);
    }
  },
  removeStoredToken(){
    if(localStorage){
      //delete axios.defaults.headers.common['Authorization'];
      localStorage.removeItem('app-token');
    }
  }
}

const state = {
  app_locale: 'de',
  app_logged_in:false,
  app_user:{},
  app_alias:null,
  app_session:null,
  app_loading:false,
  app_auth_error:false,
  app_stripe_id:null
}

// getters
const getters = {
  isLoggedIn:state=>{
    return state.app_logged_in;
  },
  aliasUser:state=>{
    return (state.app_alias)?state.app_alias:state.app_user;
  },
  userId:state => {
    return (state.app_user)?state.app_user.id:null
  },
  isAdmin:state => {
    return (state.app_user)?(state.app_user.roles && Vue._.includes(state.app_user.roles,CONFIG.ROLE_ADMIN)):false
  },
  
  isConnectedWithStripe:state=>{
    return (state.app_user && state.app_user.stripeUserId!=null)
  }
}

// actions
const actions = {
  initSession ({ commit }) {
    commit('SET_APP_LOADING', true);
    return new Promise((resolve) => {
      api.initSession().then((response)=>{
        let app_session=methods.getXSRFToken();
        let data=(response && response.data && response.data.user)?response.data.user:null;
        let stripeClientId=(response && response.data)?response.data.stripeClientId:null;
        commit('SET_APP_ALIAS', null);
        commit('SET_APP_USER', data);
        commit('SET_APP_STRIPE_ID', stripeClientId);
        commit('SET_APP_SESSION', app_session);
        resolve(app_session);
      }).catch(()=>{
        commit('SET_APP_SESSION', null);
        commit('SET_APP_LOGGED_IN', false);
        commit('SET_APP_ALIAS', null);
        commit('SET_APP_USER', null);
        resolve(); // if you call reject - a new logged in user will be in a login loop
      }).finally(()=>{
        commit('SET_APP_LOADING', false);
      })
    })
  },

  login ({ commit },credentials) {
    commit('SET_APP_AUTH_ERROR', false);
    commit('SET_APP_LOADING', true);

    return new Promise((resolve, reject) => {
      api.login(credentials).then(response=>{
        let data=(response && response.data && response.data.user)?response.data.user:null;
        let stripeClientId=(response && response.data)?response.data.stripeClientId:null;
        commit('SET_APP_STRIPE_ID', stripeClientId);
        commit('SET_APP_ALIAS', null);
        commit('SET_APP_USER', data);
        commit('SET_APP_LOGGED_IN', true);
        resolve(data);
      }).catch(error=>{
        commit('SET_APP_LOGGED_IN', false);
        commit('SET_APP_ALIAS', null);
        commit('SET_APP_USER', null);
        commit('SET_APP_AUTH_ERROR', true);
        reject(error);
      }).finally(()=>{
        commit('SET_APP_LOADING', false);
      })
    })
  },
  logout ({ commit }) {
    commit('SET_APP_LOADING', true);
    return new Promise((resolve, reject) => {
      api.logout().then(response=>{
        resolve(response);
      }).catch(error=>{
        reject(error);
      }).finally(()=>{
        commit('SET_APP_LOGGED_IN', false);
        commit('SET_APP_ALIAS', null);
        commit('SET_APP_USER', null);
        commit('SET_APP_LOADING', false);
      })
    })
  },
  changePassword ({ commit },d) {
    commit('SET_APP_LOADING', true);
    return new Promise((resolve, reject) => {
      api.changePassword(d).then(response=>{
        resolve(response);
      }).catch(error=>{
        reject(error);
      }).finally(()=>{
        commit('SET_APP_LOADING', false);
      })
    })
  },
  getStripeLoginLink ({ commit },userId) {
    commit('SET_APP_LOADING', true);
    return new Promise((resolve, reject) => {
      api.getStripeLoginLink(userId).then(response=>{
        if(response && response.data){
          resolve(response.data);
        }else{
          reject(null);
        }
      }).catch(error=>{
        reject(error);
      }).finally(()=>{
        commit('SET_APP_LOADING', false);
      })
    })
  },
  requestPasswordChange ({ commit },email) {
    commit('SET_APP_LOADING', true);
    return new Promise((resolve, reject) => {
      api.changePassword({
        email:email
      }).then(response=>{
        resolve(response);
      }).catch(error=>{
        reject(error);
      }).finally(()=>{
        commit('SET_APP_LOADING', false);
      })
    })
  },
  //Requests user by id.
  getUserById ({ commit },id) {

    commit('SET_APP_LOADING', true);
    return new Promise((resolve, reject) => {
      if(null!=id){
        //Request server
        api.getUserById(id).then(response=>{
          if(response && response.data){
            resolve(response.data);
          }else{
            reject(null);
          }
        }).catch(error=>{
          reject(error);
        }).finally(()=>{
          commit('SET_APP_LOADING', false);
        })
      }else{
        reject(null);
      }
    })
  },
  setAliasByUserId({ commit },id){
    return new Promise((resolve, reject) => {
      if(null==id){
        reject();
      }

      api.getUserById(id).then((response)=>{
        if(response && response.data){
          commit('SET_APP_ALIAS', response.data);
          resolve(response.data)
        }else{
          commit('SET_APP_ALIAS', null);
          reject();
        }
      }).catch((ex) => {
        commit('SET_APP_ALIAS', null);
        reject(ex);
      });
    });
  },
  updateUser ({ commit },data) {
    commit('SET_APP_LOADING', true);
    return new Promise((resolve, reject) => {
      api.updateUser(data).then(response=>{
        let data=(response && response.data)?response.data:null;
        commit('SET_ALIAS_OTHERWISE_APP_USER', data);
        resolve(response);
      }).catch(error=>{
        reject(error);
      }).finally(()=>{
        commit('SET_APP_LOADING', false);
      })
    })
  },
  register ({ commit },data) {
    commit('SET_APP_LOADING', true);

    return new Promise((resolve, reject) => {

      api.register(data).then(response=>{
        let data=(response && response.data)?response.data:null;
        commit('SET_APP_USER', data);
        resolve(data);
      }).catch(error=>{
        commit('SET_APP_USER', null);
        reject(error);
      }).finally(()=>{
        commit('SET_APP_LOADING', false);
      })
    })
  },
}

// mutations
const mutations = {
  SET_APP_LOCALE (state, payload) {
    state.app_locale = payload
  },
  SET_APP_LOGGED_IN (state, payload) {
    state.app_logged_in = payload
  },
  SET_APP_USER (state, user) {
    Vue.set(state,'app_user',user);
  },
  SET_ALIAS_OTHERWISE_APP_USER (state, user) {
    if(state.app_alias){
      console.log('SET alias');
      Vue.set(state,'app_alias',user);
    }else{
      console.log('SET user');
      Vue.set(state,'app_user',user);
    }

  },
  SET_APP_ALIAS (state, user) {
    Vue.set(state,'app_alias',user);
  },
  SET_APP_LOADING(state,val){
      Vue.set(state,'app_loading',val);
  },
  SET_APP_SESSION(state,val){
    Vue.set(state,'app_session',val);
  },
  SET_APP_STRIPE_ID(state,val){
    Vue.set(state,'app_stripe_id',val);
  },
  SET_APP_AUTH_ERROR(state,val){
    Vue.set(state,'app_auth_error',val);
  },

  //Upfate alias or own user
  UPDATE_APP_USER(state,{user,data}){
    if(!Vue._.isEmpty(user)){
      let newUserData=Vue._.merge(user,data);
      if(state.app_user && state.app_user.id == user.id){
        Vue.set(state,'app_user',newUserData);
      }else if(state.app_alias && state.app_alias.id == user.id){
        Vue.set(state,'app_alias',newUserData);
      }

    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
